import STRIPE_ENV from "../config/stripe";

export function getStripeUrls(registrationId, registrationEmail) {
  if (STRIPE_ENV === "sandbox") {
    return {
      trial: {
        url: `https://buy.stripe.com/test_bJefZab7afagcrQde14Rq02?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      monthly: {
        url: `https://buy.stripe.com/test_3cI6oA3EI8LScrQ7TH4Rq01?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      quarterly: {
        url: `https://buy.stripe.com/test_3cI6oA3EI8LScrQ7TH4Rq01?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      yearly: {
        url: `https://buy.stripe.com/test_9B6cMY7UY9PW2Rggqd4Rq04?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      "1-49": {
        url: `https://buy.stripe.com/test_4gM4gsejmgek0J88XL4Rq03?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      "tier-nano": {
        url: `https://buy.stripe.com/test_eVqaEQ7UYaU0gI6fm94Rq09?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      "tier-starter": {
        url: `https://buy.stripe.com/test_00w28ka36gekgI6b5T4Rq0a?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      "tier-basic": {
        url: `https://buy.stripe.com/test_PLACEHOLDER_BASIC?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      "tier-plus": {
        url: `https://buy.stripe.com/test_PLACEHOLDER_PLUS?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      "tier-growth": {
        url: `https://buy.stripe.com/test_PLACEHOLDER_GROWTH?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      "tier-pro": {
        url: `https://buy.stripe.com/test_PLACEHOLDER_PRO?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      "tier-scale": {
        url: `https://buy.stripe.com/test_PLACEHOLDER_SCALE?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      "tier-enterprise-1": {
        url: `https://buy.stripe.com/test_PLACEHOLDER_ENT1?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      "tier-enterprise-2": {
        url: `https://buy.stripe.com/test_PLACEHOLDER_ENT2?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      "tier-enterprise-3": {
        url: `https://buy.stripe.com/test_PLACEHOLDER_ENT3?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      "tier-enterprise-4": {
        url: `https://buy.stripe.com/test_PLACEHOLDER_ENT4?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
    };
  } else {
    return {
      trial: {
        url: `https://buy.stripe.com/5kQ5kD2IuewBfSw1mb2Ry0b?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      monthly: {
        url: `https://buy.stripe.com/8x2dR982OfAF6hWgh52Ry0c?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      quarterly: {
        url: `https://buy.stripe.com/14AaEX3MycotgWA5Cr2Ry0m?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      yearly: {
        url: `https://buy.stripe.com/6oUcN5aaW605ayc7Kz2Ry0d?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      "1-49": {
        url: `https://buy.stripe.com/14AeVdcj43RXdKod4T2Ry0e?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      "tier-nano": {
        url: `https://buy.stripe.com/9B6dR9gzkbkp49Od4T2Ry0n?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      "tier-starter": {
        url: `https://buy.stripe.com/cNi28r4QC88d8q46Gv2Ry0o?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      "tier-basic": {
        url: `https://buy.stripe.com/9B68wP6YKgEJgWA2qf2Ry0w?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      "tier-plus": {
        url: `https://buy.stripe.com/00w5kD82O9ch49Oc0P2Ry0q?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      "tier-growth": {
        url: `https://buy.stripe.com/aFafZh4QCfAFayc3uj2Ry0r?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      "tier-pro": {
        url: `https://buy.stripe.com/aFa9ATgzkdsxfSw5Cr2Ry0s?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      "tier-scale": {
        url: `https://buy.stripe.com/9B65kD1Eq60549O3uj2Ry0t?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      "tier-enterprise-1": {
        url: `https://buy.stripe.com/00w7sLaaW9ch0XC5Cr2Ry0u?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      "tier-enterprise-2": {
        url: `https://buy.stripe.com/14AbJ11EqbkpdKoe8X2Ry0v?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      "tier-enterprise-3": {
        url: `https://buy.stripe.com/fZueVdgzk4W18q46Gv2Ry0x?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      "tier-enterprise-4": {
        url: `https://buy.stripe.com/28E00jfvgcot0XCd4T2Ry0y?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      P500: {
        url: `https://buy.stripe.com/bJe4gz1EqgEJgWA2qf2Ry0T?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      P1000: {
        url: `https://buy.stripe.com/3cIbJ1gzkcotfSw1mb2Ry0U?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      P1500: {
        url: `https://buy.stripe.com/00w8wPfvgdsxdKo7Kz2Ry0V?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      P2000: {
        url: `https://buy.stripe.com/cNidR95UG3RXdKo6Gv2Ry0W?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      P2500: {
        url: `https://buy.stripe.com/28E28rgzk9chgWAaWL2Ry0X?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      P3000: {
        url: `https://buy.stripe.com/4gMfZhgzk1JP35Kc0P2Ry0Y?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      P3500: {
        url: `https://buy.stripe.com/14A14nfvg9chfSw2qf2Ry0Z?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      P4000: {
        url: `https://buy.stripe.com/8x29AT96Scot8q45Cr2Ry10?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      P4500: {
        url: `https://buy.stripe.com/14AeVd1Eqdsx21Ge8X2Ry11?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      P5000: {
        url: `https://buy.stripe.com/cNi9AT96ScotfSwgh52Ry12?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      P5500: {
        url: `https://buy.stripe.com/6oUaEX1Eq605eOsfd12Ry13?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      P6000: {
        url: `https://buy.stripe.com/cNi9ATfvgdsx0XC9SH2Ry14?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      P6500: {
        url: `https://buy.stripe.com/8x200jaaWdsxbCg3uj2Ry15?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      P7000: {
        url: `https://buy.stripe.com/28E00jercgEJ7m08OD2Ry16?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      P7500: {
        url: `https://buy.stripe.com/5kQ7sLgzk88dcGke8X2Ry17?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      P8000: {
        url: `https://buy.stripe.com/3cIfZhercewB9u86Gv2Ry18?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      P8500: {
        url: `https://buy.stripe.com/7sY00jdn81JP8q45Cr2Ry19?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      P9000: {
        url: `https://buy.stripe.com/00w28rdn8coteOsfd12Ry1a?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      P9500: {
        url: `https://buy.stripe.com/14A8wPbf02NTfSw6Gv2Ry1b?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
      P10000: {
        url: `https://buy.stripe.com/14AfZhcj46055dS8OD2Ry1c?client_reference_id=${registrationId}&prefilled_email=${registrationEmail}`,
      },
    };
  }
}

export function getCustomerPortal(registrationEmail) {
  if (STRIPE_ENV === "sandbox") {
    return `https://billing.stripe.com/p/login/test_aFa14g7UY8LS4Zode14Rq00?prefilled_email=${registrationEmail}`;
  } else {
    return `https://billing.stripe.com/p/login/00w6oH3My9ch9u8c0P2Ry00?prefilled_email=${registrationEmail}`;
  }
}

export function getStripePricing() {
  return {
    trial: {
      price: "$1.99",
    },
    monthly: {
      price: "$1.99",
    },
    quarterly: {
      price: "$5.97",
    },
    yearly: {
      price: "$21.97",
    },
  };
}
